import React from 'react';

const ShortAnswerQuestion = ({
  question,
  answers,
  onAnswerChange,
  questionIndex
}) => {
  const handleAnswerChange = (value) => {
    onAnswerChange(question.id, value);
  };

  const getCurrentAnswer = () => {
    return answers[question.id] || '';
  };

  return (
    <div className="bg-gray-100 border border-gray-200 rounded-lg p-4 sm:p-6 w-full">
      {/* Problem Description */}
      {question.context && (
        <div className="mb-4 sm:mb-6">
          <p className="text-gray-700 text-base leading-relaxed">
            {question.context}
          </p>
        </div>
      )}

      {/* Financial Data Table */}
      {question.financialData && question.financialData.length > 0 && (
        <div className="mb-4 sm:mb-6 overflow-x-auto">
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <div className="grid grid-cols-2 divide-x divide-gray-200">
              {/* Left Column - Labels */}
              <div className="p-3 sm:p-4 bg-gray-50">
                <span className="text-gray-700 font-medium text-sm sm:text-base">Financial Items</span>
              </div>
              {/* Right Column - Values */}
              <div className="p-3 sm:p-4 bg-gray-50">
                <span className="text-gray-700 font-medium text-sm sm:text-base">$</span>
              </div>
            </div>
            
            {/* Data Rows */}
            <div className="divide-y divide-gray-200">
              {question.financialData.map((item, index) => (
                <div key={index} className="grid grid-cols-2 divide-x divide-gray-200">
                  <div className="p-3 sm:p-4">
                    <span className="text-gray-800 text-sm sm:text-base">
                      {item.label}
                    </span>
                  </div>
                  <div className="p-3 sm:p-4">
                    <span className="text-gray-800 text-sm sm:text-base font-medium">
                      {item.value.toLocaleString()}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Additional Information */}
      {question.additionalInfo && (
        <div className="mb-4 sm:mb-6">
          <p className="text-gray-700 text-base leading-relaxed">
            {question.additionalInfo}
          </p>
        </div>
      )}

      {/* Question Text */}
      <div className="mb-4 sm:mb-6">
        <p className="text-gray-900 text-base font-bold leading-relaxed">
          {question.text || question.question}
        </p>
      </div>

      {/* Answer Input */}
      <div className="bg-white p-3 sm:p-4 rounded border border-gray-200">
        <input
          type="text"
          value={getCurrentAnswer()}
          onChange={(e) => handleAnswerChange(e.target.value)}
          placeholder=""
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-base"
        />
      </div>

      {/* Answer status removed as requested */}
    </div>
  );
};

export default ShortAnswerQuestion;